query TransactionStatusChartData {
  kpiTransactionStatuses(orderBy: ID_ASC) {
    nodes {
      title
      amount
      searchHint
    }
  }
}
